/* JUSTYOL — promo popup logic.
   - audience targeting: all / web / app (window.JY_IS_APP from jy-app-flag)
   - only the FIRST eligible popup shows per page load (DOM order = priority)
   - frequency: cooldown_days via localStorage; 0 = once per session
   - optional schedule window (starts/ends, Morocco time +01:00)
   - coupon tap-to-copy with visual feedback
   - Clarity mirrors: jy_popup_view / jy_popup_copy / jy_popup_cta
   - theme editor: selecting the section/block previews that popup, no capping */
(function () {
  'use strict';
  if (window.__jyPromoPopup) return;
  window.__jyPromoPopup = true;

  var DESIGN_MODE = !!(window.Shopify && Shopify.designMode);

  function clarityEvent(name) {
    try {
      if (window.clarity) window.clarity('event', name);
    } catch (e) {}
  }

  function parseWhen(s) {
    if (!s) return null;
    /* pin bare datetimes to Morocco time so campaigns flip at the right hour */
    var t = Date.parse(/[Zz]|[+-]\d\d:\d\d$/.test(s) ? s : s + ':00+01:00');
    return isNaN(t) ? null : t;
  }

  function capKey(id) {
    return 'jy_pp_' + id;
  }

  function isCapped(id, cooldownDays) {
    try {
      if (cooldownDays <= 0) return sessionStorage.getItem(capKey(id)) === '1';
      var ts = parseInt(localStorage.getItem(capKey(id)), 10);
      return !!ts && Date.now() - ts < cooldownDays * 86400000;
    } catch (e) {
      return false; /* private mode: show rather than never show */
    }
  }

  function cap(id, cooldownDays) {
    try {
      if (cooldownDays <= 0) sessionStorage.setItem(capKey(id), '1');
      else localStorage.setItem(capKey(id), String(Date.now()));
    } catch (e) {}
  }

  function eligible(el) {
    var plat = window.JY_IS_APP === true ? 'app' : 'web';
    var aud = el.getAttribute('data-pp-audience') || 'all';
    if (aud !== 'all' && aud !== plat) return false;
    var now = Date.now();
    var starts = parseWhen(el.getAttribute('data-pp-starts'));
    var ends = parseWhen(el.getAttribute('data-pp-ends'));
    if (starts && now < starts) return false;
    if (ends && now > ends) return false;
    var cd = parseInt(el.getAttribute('data-pp-cooldown'), 10) || 0;
    if (isCapped(el.getAttribute('data-pp-id'), cd)) return false;
    return true;
  }

  var openEl = null;

  function close() {
    if (!openEl) return;
    var el = openEl;
    openEl = null;
    el.classList.remove('is-open');
    setTimeout(function () {
      el.hidden = true;
    }, 360);
    document.removeEventListener('keydown', onKey);
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
  }

  function open(el, skipCap) {
    if (openEl) return;
    openEl = el;
    el.hidden = false;
    /* next frame so the transition runs */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.add('is-open');
      });
    });
    if (!skipCap) {
      cap(el.getAttribute('data-pp-id'), parseInt(el.getAttribute('data-pp-cooldown'), 10) || 0);
    }
    clarityEvent('jy_popup_view');
    document.addEventListener('keydown', onKey);
  }

  function boot() {
    /* scope to our own container — the PDP multi-piece picker (#JyPiecePicker)
       reuses [data-jy-pp] too, and a global query would grab it and open() it
       (stripping its hidden), showing an empty picker on product-page load */
    var pops = document.querySelectorAll('[data-jy-pp-root] [data-jy-pp]');
    if (!pops.length) return;

    /* wiring shared by all popups */
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-jy-pp-close]')) {
        close();
        return;
      }
      var cta = e.target.closest('[data-jy-pp-cta]');
      if (cta) {
        clarityEvent('jy_popup_cta');
        /* let the link navigate */
        return;
      }
      var cp = e.target.closest('[data-jy-pp-copy]');
      if (cp) {
        var code = cp.getAttribute('data-jy-pp-copy') || '';
        var done = function () {
          cp.classList.add('is-copied');
          var lbl = cp.querySelector('[data-jy-pp-copylbl]');
          if (lbl) lbl.textContent = document.documentElement.lang === 'ar' ? 'تم النسخ ✓' : 'Copié ✓';
          clarityEvent('jy_popup_copy');
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try {
            document.execCommand('copy');
          } catch (err) {}
          document.body.removeChild(ta);
          done();
        }
      }
    });

    if (DESIGN_MODE) {
      /* theme editor: preview the block being edited, never cap */
      document.addEventListener('shopify:block:select', function (e) {
        var el = e.target && e.target.closest ? e.target.closest('[data-jy-pp]') || e.target.querySelector('[data-jy-pp]') : null;
        if (el) {
          close();
          open(el, true);
        }
      });
      document.addEventListener('shopify:block:deselect', close);
      document.addEventListener('shopify:section:deselect', close);
      return;
    }

    /* live: first eligible popup wins */
    for (var i = 0; i < pops.length; i++) {
      if (eligible(pops[i])) {
        var el = pops[i];
        var delay = (parseInt(el.getAttribute('data-pp-delay'), 10) || 0) * 1000;
        setTimeout(function () {
          /* re-check: user may have opened the COD express popup meanwhile */
          if (!document.querySelector('.jy-codx:not([hidden])')) open(el);
        }, delay);
        break;
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
